import React from 'react';

const PDFViewer = ({ fileUrl, onClose }) => {
  const handleDownload = () => {
    if (fileUrl) {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = 'document.pdf';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const googleViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-4 rounded-lg w-4/5 h-5/6 flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium text-gray-800">Document Viewer</h3>
          <div className="flex gap-4">
            <button
              onClick={handleDownload}
              className="text-blue-500 hover:text-blue-700 flex items-center gap-2 px-3 py-1 border border-blue-500 rounded-md">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
              <span className="text-sm">Download</span>
            </button>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700 px-2 py-1">
              ✕
            </button>
          </div>
        </div>
        <div className="flex-1 bg-gray-100 rounded-lg overflow-hidden">
          <iframe
            src={googleViewerUrl}
            className="w-full h-full border-0"
            title="PDF Viewer"
          />
        </div>
      </div>
    </div>
  );
};

export default PDFViewer;